import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import classNames from "classnames";

// Component duplicated in the provider-panel module
// todo: move to ui and refactor?
// web/app/provider-panel/components/delete-button/DeleteButton.js
const DeleteButton = React.memo(({ className, ...props }) => (
  <button
    {...props}
    className={classNames(styles.deleteButton, className)}
  />
));

DeleteButton.propTypes = {
  className: PropTypes.string,
};

export default DeleteButton;
